// extracted by mini-css-extract-plugin
module.exports = {"legalText":"LegalText_legalText__2d4P9","disabled":"LegalText_disabled__sTjY8"};